import {QuestionList} from '../../types';
import Img from '../../img/scenes/page_07.jpg'

export const Day2: QuestionList = [{
    id: 101,
    question: `
    <p>До вас сідають троє пасажирів. Щойно ви рушаєте, запитують, чи можемо їхати трохи іншою дорогою, аби підвезти додому одного з трьох хлопців.
Ви бачите, що це додаткових 4 км дороги й взагалі не по дорозі. Що робити?</p>`,
    img: Img,
    answers: [
        {
            id: 1,
            text: 'Прошу пасажирів поставити ще одну адресу в застосунку',
            next: 102,
        },
        {
            id: 2,
            text: 'Погоджуюсь, аби догодити',
            next: 201,
        },
    ],
},
    {
        id: 201,
        question: `
    <p>Пасажири дякують і додають, що вони студенти і не мають додаткових коштів.
Дорогою ви натрапляєте на невеликий затор. Як відреагуєте?</p>`,
        answers: [
            {
                id: 1,
                text: 'Подумаю, що, мабуть, востаннє я на таке погодився',
                next: 202,
            },
            {
                id: 2,
                text: 'Терпляче їхатиму, що вдієш',
                next: 203,
            },
        ],
    },
    {
        id: 202,
        question: `Коли ви всіх розвезли, то отримали 5 зірок – вдячні студенти.`,
        rate: 5,
        answers: [
            {
                id: 1,
                text: 'До наступного дня',
                next: 0,
            },
        ],
    },
    {
        id: 203,
        question: `Коли ви всіх розвезли, то отримали 5 зірок і 10 грн чайових – вдячні студенти.`,
        rate: 5,
        answers: [
            {
                id: 1,
                text: 'До наступного дня',
                next: 0,
            },
        ],
    },
    {
        id: 102,
        question: `Пасажири вмовляють обійтися без цього, бо вони студенти й не мають лишніх коштів`,
        answers: [
            {
                id: 1,
                text: 'Відмовити',
                next: 204,
            },
            {
                id: 2,
                text: 'Погодитись',
                next: 103,
            },
        ],
    },
    {
        id: 204,
        question: `Пасажири невдоволено шепочуться позаду. Ваші дії?`,
        answers: [
            {
                id: 1,
                text: 'Поясню, що труднощі з грошима не лише у них',
                next: 205,
            },
            {
                id: 2,
                text: 'Мовчатиму',
                next: 206,
            },
        ],
    },
    {
        id: 205,
        question: `Хлопці замовкають і так всі прямують до кінця шляху. Ви отримуєте від них 4 зірки`,
        rate: 4,
        answers: [
            {
                id: 1,
                text: 'Перейти до наступного дня',
                next: 0,
            },
        ],
    },
    {
        id: 206,
        question: `Через певний час хлопці замовкають і самі. Ви отримуєте 3 зірки за поїздку.`,
        rate: 3,
        answers: [
            {
                id: 1,
                text: 'Перейти до наступного дня',
                next: 0,
            },
        ],
    },
    {
        id: 103,
        question: `Дорогою ви натрапляєте на невеликий затор. Як відреагуєте?`,
        answers: [
            {
                id: 1,
                text: 'Подумаю, що, мабуть, востаннє я на таке погодився',
                next: 202,
            },
            {
                id: 2,
                text: 'Терпляче їхатиму, що вдієш',
                next: 203,
            },
        ],
    },


];